import {apiOption, apiUrl, apiResponse} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'
import context from '../context'
import {SUBSCRIBE_VERSION, VERSION_UPDATED} from './protocol'

const NAMESPACE = 'App'

export const LINKS_LOADED = NAMESPACE + '/LinksLoaded'
export const VERSION_LOADED = NAMESPACE + '/VersionLoaded'
// middleware action
export const ACTION_FAILED = NAMESPACE + '/ActionFailed'

var subscribeVersionSocket

export function loadLinks() {
    return loading(fetch(config.api.url, apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: LINKS_LOADED,
            _links: json._links
        }
    }), LINKS_LOADED)
}

export function subscribeVersion() {
    return (state, {getState, dispatch}) => {
        if (!subscribeVersionSocket) {
            subscribeVersionSocket = context.getFrontWebSocket()

            subscribeVersionSocket.addEventListener('open', function() {
                const state = getState()
                const {version} = state.app

                this.send(JSON.stringify({
                    type: SUBSCRIBE_VERSION,
                    catchup: version && version.hash
                }))
            })

            subscribeVersionSocket.addEventListener('message', function(event) {
                const data = JSON.parse(event.data)

                switch(data.type) {
                    case VERSION_UPDATED:
                        dispatch({
                            type: VERSION_LOADED,
                            version: data.version  
                        })
                        break
                }
            })

            if (subscribeVersionSocket.readyState == WebSocket.OPEN) {
                const {version} = state.app

                this.send(JSON.stringify({
                    type: SUBSCRIBE_VERSION,
                    catchup: version && version.hash
                }))
            }
        }

        return subscribeVersionSocket
    }
}


// WEBPACK FOOTER //
// ./lib/app/actions.js